import React from 'react'
import Forms from './Forms'

export default function InnerBanner(props) {
  return (
    <>

  <section className="banner">
    <div className="container-fluid">
        <div className="row">
            <div className="col-md-12 p-0">
                <div className="sub-banner">
                    <div id="carouselFade" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-pause="false" data-bs-interval="3000">
                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <img src={`${props.imgPath}`} className="d-block w-100" alt="..." />
                            <div className="carousel-caption">
                                <h1>{props.innerTitle}</h1>
                                
                              </div>
                          </div>                        
                    </div>
                    
                    <div className="queryForm">
                    
                        <h2>Any Query? <strong>Call Now</strong></h2>
                    <Forms submitBtnName="Submit"/>
                    
                </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</section>
    </>
  )
}
